import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  root: {
    // We need to set this nonsense value to make sure the banner overlays all HVS page elements.
    zIndex: 3000000,
    minWidth: "calc(100% - 370px)",
    left: 320,
    right: theme.hv.spacing.md,
    transform: "none",
  },
}));

export default styles;
